import React from 'react';
var CopySVG = function CopySVG(_ref) {
    var height = _ref.height, className = _ref.className;
    return /*#__PURE__*/ React.createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 27 31",
        height: height,
        className: className
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M2.12,29h17.76V7H2.12V29z M5.12,2v3h16.76v21h3V2H5.12z"
    }));
};
export default CopySVG;
